import React from 'react';
import { useParams } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { SEOHead } from '../components/SEOHead';
import { Story } from '../components/Story';
import { Quality } from '../components/Quality';
import { Certifications } from '../components/Certifications';

const SITE = process.env.REACT_APP_SITE_URL || 'https://cajeta-hacienda-real.com';

const aboutSchema = (lang, region) => ({
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  '@id': `${SITE}/${region}/about/#webpage`,
  'url': `${SITE}/${region}/about`,
  'name': lang === 'es'
    ? 'Nuestra Historia – Cajeta Artesanal de Leche de Vaca desde 1950 | Hacienda Real'
    : 'Our Story – Artisan Cow\'s Milk Cajeta since 1950 | Hacienda Real',
  'description': lang === 'es'
    ? 'Conoce la historia de Hacienda Real, productores artesanales de cajeta de leche de vaca desde 1950 en San Juan de los Lagos, Jalisco. Calidad, tradición y productos 100% naturales.'
    : 'Discover the story of Hacienda Real, artisan producers of cow\'s milk cajeta since 1950 in San Juan de los Lagos, Jalisco. Quality, tradition, and 100% natural products.',
  'isPartOf': { '@id': `${SITE}/#website` },
  'about': { '@id': `${SITE}/#organization` },
  'inLanguage': lang === 'es' ? 'es-MX' : 'en-US',
  'breadcrumb': {
    '@type': 'BreadcrumbList',
    'itemListElement': [
      {
        '@type': 'ListItem',
        'position': 1,
        'name': 'Hacienda Real',
        'item': `${SITE}/${region}`,
      },
      {
        '@type': 'ListItem',
        'position': 2,
        'name': lang === 'es' ? 'Nuestra Historia' : 'Our Story',
        'item': `${SITE}/${region}/about`,
      },
    ],
  },
});

export default function AboutPage() {
  const { region = 'mx' } = useParams();
  const { lang } = useLanguage();

  const title = lang === 'es'
    ? 'Nuestra Historia – Cajeta Artesanal de Leche de Vaca desde 1950'
    : 'Our Story – Artisan Cow\'s Milk Cajeta since 1950';
  const description = lang === 'es'
    ? 'Desde 1950 elaboramos cajeta y dulces naturales de leche de vaca en San Juan de los Lagos, Jalisco. Descubre nuestra historia, proceso artesanal y compromiso con la calidad natural.'
    : 'Since 1950 we have crafted cajeta and natural dairy sweets from cow\'s milk in San Juan de los Lagos, Jalisco. Discover our story, artisan process, and commitment to natural quality.';

  return (
    <>
      <SEOHead
        title={title}
        description={description}
        canonical={`/${region}/about`}
        lang={lang}
        altLang={{ es: '/mx/about', en: '/us/about' }}
        schema={aboutSchema(lang, region)}
      />
      <Story />
      <Quality />
      <Certifications />
    </>
  );
}
